import { Text } from '../../components/Text'

interface Props {
  title: string
  children: React.ReactNode
  every?: string
  time?: string
  highlighted?: boolean
}

export default function Announcement({ title, children, every, time, highlighted }: Props) {
  return (
    <div className='flex w-full flex-col items-start gap-y-4 tracking-[0px]'>
      <div className='flex flex-col gap-y-1'>
        <Text.H5 gradient={highlighted}>
          {every} at {time}
        </Text.H5>
        <Text.H4>{title}</Text.H4>
      </div>
      <Text.Body>
        <p>{children}</p>
      </Text.Body>
    </div>
  )
}
